require('./manage-shares.styles');

const template = require('./manage-shares.template');

class ManageSharesController implements ng.IComponentController {
	public static $inject = [];
	
	public ManageSharesController() {
	}
}

export const ManageSharesComponent:ng.IComponentOptions = {
	template,
	controller: ManageSharesController,
	controllerAs: 'vm',
	bindings: {
		token: '<'
	}
}


// WEBPACK FOOTER //
// ./src/shaas/components/manage-shares/manage-shares.ts